import type { YamadaProduct } from '../models/yamada-product';
import type { MemberRow } from './member-row';

/** 「2026/10/14」「2026-10-14」→「10/14」 */
const monthDay = (s: string): string => {
  const m = (s ?? '').match(/^\d{4}[/-](\d{1,2})[/-](\d{1,2})/);
  return m ? `${Number(m[1])}/${Number(m[2])}` : s;
};

/**
 * 改廃リストの利益商品で、まだ在庫照合していない（店の在庫が無い）ヤマダの商品 → 下の別枠の行（2026-10-20 ユーザー指定）。
 * LINE 報告と同じ形（画像・Keepa・JAN/ASIN・Amazon 価格と仕入値・利益・商品名）。仕入値は改廃の売価（POS）
 */
export function uncheckedToRow(p: YamadaProduct): MemberRow {
  return {
    key: `unchecked-${p.id}`,
    asin: p.asin,
    jan: p.jan,
    imageUrl: p.imageUrl,
    productName: p.name,
    // エクセル用 CSV で「改廃リスト」の 1 列になるよう、1 行にまとめる
    details: [`改廃リスト: ${monthDay(p.registrationDate)}（在庫未確認）`],
    boughtPastMonth: p.boughtPastMonth,
    amazonPrice: p.amazonPrice,
    amazonPriceSource: p.amazonPriceSource,
    lastKnownPriceAt: p.lastKnownPriceAt,
    cost: p.price,
    fbaProfitPrice: p.profitPrice,
    fbaProfitRate: p.profitRate,
    line: '',
  };
}

/**
 * 画面の下の枠（LINE 報告＋改廃の在庫未確認）の行を作る（2026-10-20 ユーザー指定）。
 * LINE 報告を先（新しい順のまま）、続けて改廃の在庫未確認。同じ JAN が両方にあれば 1 行にまとめ、
 * 報告の行の頭に「改廃リスト: M/D」を足す。報告で仕入値が読めなかった時は改廃の売価（POS）とその利益を使う
 */
export function mergeBottomRows(reportRows: MemberRow[], uncheckedRows: MemberRow[]): MemberRow[] {
  const byJan = new Map(uncheckedRows.map((u) => [u.jan, u]));
  const used = new Set<string>();
  const merged = reportRows.map((r) => {
    const u = byJan.get(r.jan);
    if (!u) {
      return r;
    }
    used.add(u.jan);
    const kaihai = u.details.filter((d) => d.startsWith('改廃リスト'));
    const useKaihaiCost = r.cost == null && u.cost != null;
    return {
      ...r,
      details: [...kaihai, ...r.details],
      cost: useKaihaiCost ? u.cost : r.cost,
      fbaProfitPrice: useKaihaiCost ? u.fbaProfitPrice : r.fbaProfitPrice,
      fbaProfitRate: useKaihaiCost ? u.fbaProfitRate : r.fbaProfitRate,
    };
  });
  return [...merged, ...uncheckedRows.filter((u) => !used.has(u.jan))];
}
